import React from "react"
//import I18n from "i18n-js/index.js.erb"

class PaymentLogPresenterPaymentLogFoliosWidget extends React.Component {
  constructor(props) {
    super(props);
  };

  render() {
    if (this.props.payment_log.payment_log_folios && this.props.payment_log.payment_log_folios.length > 0) {
      var folios = this.props.payment_log.payment_log_folios.map((plf, idx) => {
        return (
          <div className="folio-amount" key={plf.folio_id}>
            <div className="row" style={{ margin: '0px' }}>

              <div className="col-sm-3">
                <label>{I18n.t('folio')}</label>
                <br />
                <div>{plf.room ? `${plf.name} - ${plf.room}(${plf.room_type})` : plf.room_type ? `${plf.name} - ${plf.room_type}` : plf.name}</div>
              </div>


              <div className="col-sm-3">
                <label>{I18n.t('paid_to_folio')}</label>
                <br />
                <div>{this.props.formatCurrency(plf.paid_to_folio)}</div>
              </div>

              {
                this.props.payment_log.payment_type.name === 'cash' || this.props.payment_log.payment_type.name === 'voucher' || this.props.payment_log.payment_type.name === 'rentals_united'
              ?
              null
              :
              <div className="col-sm-3">
                <label>{I18n.t('refunded_to_folio')}</label>
                <div>{this.props.formatCurrency(plf.refunded_to_folio * -1)}</div>
              </div>
              }
            </div>
            {this.props.payment_log.payment_log_folios.length > 1 && (idx != this.props.payment_log.payment_log_folios.length - 1) ? <hr /> : null}
          </div>
        );
      });
    };

    return(
          <div className="panel panel-default">
            <div className="panel-body container">
              <h3 className="panel-heading-text" style={{ borderBottom: '1px solid #DFDFDF' }}>{I18n.t('folios')}</h3>
              <div className={"folios "}>
                {folios && folios.length ? folios : <div className="no-records"><span className="none">{I18n.t('none')}</span></div>}
              </div>
            </div>
          </div>
    );
  };
};

export default PaymentLogPresenterPaymentLogFoliosWidget